
const STATS_URL = process.env.REACT_APP_STATS_URL;

const STATS_BASE_URL = `${STATS_URL}/stats`;

// stats server collect following metrics with success or fail status
// please do not put sensitive information when add new metric

const WEBMAIL_METRIC_DESC = 'description';
const WEBMAIL_METRIC_NAME = 'name';
const WEBMAIL_METRIC_NAME_RENDER = 'render';
const WEBMAIL_METRIC_NAME_ATTDOWNLOAD = 'attDownload';
const WEBMAIL_METRIC_NAME_DECRYPTION = 'decryption';
const WEBMAIL_METRIC_STATUS = 'status';
const WEBMAIL_METRIC_STATUS_SUCCESS = 'success';
const WEBMAIL_METRIC_STATUS_FAIL = 'fail';

const METRIC = Object.freeze({
  GET_MSG: WEBMAIL_METRIC_NAME_RENDER,
  GET_ATTACH: WEBMAIL_METRIC_NAME_ATTDOWNLOAD,
  DECRYPT: WEBMAIL_METRIC_NAME_DECRYPTION,
});

const STATUS = Object.freeze({
  SUCCESS: WEBMAIL_METRIC_STATUS_SUCCESS,
  FAIL: WEBMAIL_METRIC_STATUS_FAIL,
});

const STATS_HEADERS = {
  'Content-Type': 'application/json',
  'Accept': '*/*',
  'Access-Control-Allow-Origin': '*',
};

/**
 * token
 */
class Stats {
  /**
   * Construct a stats client
   */
  constructor() {
    const searchParams = new URLSearchParams(window.location.search);
    this.qsParams = new URLSearchParams({
      id: searchParams.get('id'),
      dc: searchParams.get('dc'),
      tok: searchParams.get('tok'),
    });
    this.STATS_URL_WITH_QS = `${STATS_BASE_URL}?${this.qsParams.toString()}`;
  }

  METRIC = METRIC;

  STATUS = STATUS;

  /**
   * Increment the stat of given type
   * @param {Stats.METRIC} metric
   * @param {Stats.STATUS} status
   * @param {?string} description
   * @return {Response}
   */
  async pushStat(metric, status, description = '') {
    console.log(`Push stat (${metric}, ${status}, ${description})`);
    try {
      const resp = await fetch(this.STATS_URL_WITH_QS, {
        method: 'POST',
        headers: STATS_HEADERS,
        redirect: 'follow',
        body: JSON.stringify({
          [WEBMAIL_METRIC_NAME]: metric,
          [WEBMAIL_METRIC_STATUS]: status,
          [WEBMAIL_METRIC_DESC]: description || '',
        }),
      });
      if (!resp.ok) {
        throw resp;
      }
      return resp;
    } catch (error) {
      console.log(`
  Stat push failed: (${metric}, ${description})
  Reason: ${error}
      `);
    }
  }

  /**
   * Wrap an async function and pushes the success and or failure stats on
   *  promise resolve / reject
   * @param {Object} statConfig
   * @param {METRIC} statConfig.metric
   * @param {string} statConfig.description string containing addl information
   * @param {function} func
   * @return {function} async function wrapped with metric reports on promise
   *  resolve and reject
   */
  withMetric(statConfig, func) {
    const statsInstance = this;
    return async function(...args) {
      try {
        // eslint-disable-next-line no-invalid-this
        const result = await func.call(this, ...args);
        // Promise resolved, push SUCCESS metric
        statsInstance.pushStat(
            statConfig.metric,
            STATUS.SUCCESS,
            statConfig.description,
        );
        return result;
      } catch (error) {
        // ignore AbortErrors caused by user requested cancellation
        const isAbortError =
          error instanceof DOMException && error?.name === 'AbortError';
        if (!isAbortError) {
          statsInstance.pushStat(
              statConfig.metric,
              STATUS.FAIL,
              statConfig.description,
          );
        }
        // rethrow the error
        throw error;
      }
    };
  }
}
const stats = new Stats();
export default stats;
